module.exports = __webpack_public_path__ + "static/media/shape-copy.41c495a9.svg";